"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var legacy_1 = require("satcheljs/lib/legacy");
var store_1 = require("../store/store");
var mobx_1 = require("mobx");
var loadLocalizedStrings_1 = require("./loadLocalizedStrings");
var registerStringPackageInternal = legacy_1.action('registerStringPackageInternal')(function registerStringPackageInternal(packageName, initialStrings) {
    var stringModule = {
        name: packageName,
        strings: new mobx_1.ObservableMap(initialStrings),
    };
    store_1.default.registeredStringModules.set(packageName, stringModule);
    loadLocalizedStrings_1.default(packageName, true);
});
var updatePackageWithPrefetchedStrings = legacy_1.action('updatePackageWithPrefetchedStrings')(function updatePackageWithPrefetchedStrings(stringModule, prefetchedStrings) {
    stringModule.locale = store_1.default.currentLocale;
    stringModule.strings = new mobx_1.ObservableMap(prefetchedStrings);
});
function registerStringPackage(packageName, prefetchedStrings, stringKeys) {
    if (store_1.default.registeredStringModules.has(packageName)) {
        var registeredPackage = store_1.default.registeredStringModules.get(packageName);
        if (prefetchedStrings) {
            updatePackageWithPrefetchedStrings(registeredPackage, prefetchedStrings);
        }
        return registeredPackage;
    }
    var initialStrings = prefetchedStrings;
    if (!initialStrings) {
        initialStrings = {};
        if (stringKeys) {
            stringKeys.forEach(function (key) { return (initialStrings[key] = ''); });
        }
    }
    registerStringPackageInternal(packageName, initialStrings);
    return store_1.default.registeredStringModules.get(packageName);
}
exports.default = registerStringPackage;
